import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StaffGuardService implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {

    return this.authService.userIsStaffGuard()
      .pipe(
        map(userProfile => {
          if (userProfile) {
            if (!userProfile.isStaff) {
              this.router.navigate(['/customer']);
            }
            return userProfile.isStaff;
          } else {
            this.router.navigate(['/login']);
            return false;
          }
        })
      );

  }
}
